export default __webpack_public_path__ + "9f43b1ab9f774af8db05db13aa4cb8f8.svg";